import * as types from './constants';

// Delete Regularusers Group
export const deleteRegularusersGroupRequest = data => (
  { type: types.DELETE_REGULARUSERS_GROUP_REQUEST, payload: data }
);

export const deleteRegularusersGroupDone = data => (
  { type: types.DELETE_REGULARUSERS_GROUP_DONE, payload: data }
);

export const deleteRegularusersGroupFailed = errors => (
  { type: types.DELETE_REGULARUSERS_GROUP_FAILED, payload: errors }
);